/* eslint no-inline-comments: 0 */

const List = () => import( /* webpackChunkName: "group-help-center" */ `./list.vue` );
const Add = () => import( /* webpackChunkName: "group-help-center" */ `./add.vue` );
const Edit = () => import( /* webpackChunkName: "group-help-center" */ `./edit.vue` );

export default {
	path: `help-center`,
	children: [
		{
			path: ``,
			name: `list-help-center`,
			component: List,
			meta: {
				title: `Help Center`
			}
		},
		{
			path: `new`,
			name: `add-help-center`,
			component: Add,
			meta: {
				title: `Add Article`
			}
		},
		{
			path: `:uuid`,
			name: `edit-help-center`,
			component: Edit,
			meta: {
				title: `Edit Article`
			}
		}
	]
};
